/**
* @file 营销管理-轮播广告
* */
<template>
  <div id="sticker">
    <custom-table ref="customTable" :customOptions="customOptions" :columns="columns" 
      :addText="$refs.customTable && $refs.customTable.table.total >= 10 ? '' : '新增广告'" :paging="false"
      @addFn="advertisingAdd">
      <template slot="table-operation">
        <el-table-column label="操作" fixed="right" width="160px">
          <div slot-scope="{row, $index}" class="custom-action">
            <el-tooltip content="编辑" placement="top">
              <i class="iconfont icon-compile" @click="advertisingClick(row)"></i>
            </el-tooltip>
            <el-tooltip content="删除" placement="top">
              <i class="iconfont icon-delete" @click="removeClick(row)"></i>
            </el-tooltip>
            <el-tooltip content="下移" placement="top" v-if="$index !== $refs.customTable.table.total - 1">
              <i class="iconfont icon-move-down" @click="moveClick(row, 'down', $index)"></i>
            </el-tooltip>
            <el-tooltip content="上移" placement="top" v-if="$index !== 0">
              <i class="iconfont icon-move-up" @click="moveClick(row, 'up', $index)"></i>
            </el-tooltip>
          </div>
        </el-table-column>
      </template>
      <template slot-scope="{item, row}">
        <template v-if="item.prop === 'status'">
          <div class="custom-switch" @click="switchClick(row)">
            <el-switch disabled v-model="row.status" :active-value="1" :inactive-value="2"></el-switch>
          </div>
        </template>
        <template v-else-if="item.prop === 'jumpTo'">
          <div v-if="row.jumpType == 5">{{ row.jumpTo ? JSON.parse(row.jumpTo).name : '-' }}</div>
          <div v-else>{{row.jumpTo || '-'}}</div>
        </template>
        <template v-else>{{ row[item.prop] ? row[item.prop] : '-' }}</template>
      </template>
    </custom-table>

    <el-drawer :visible.sync="visibleDrawer" :before-close="advertisingClose">
      <stickerForm :visible.sync="visibleDrawer" :id="id" @advertisingClose="advertisingClose" />
    </el-drawer>
  </div>
</template>

<script>
export default {
  name: "sticker",
  components: {
    stickerForm: () => import("./stickerForm")
  },
  data() {
    return {
      // 配置项
      customOptions: {
        // 请求的列表url
        url: '/api/v1/manage/banner/sticker'
      },
      // 表头
      columns: [
        { prop: 'sort', label: '顺序' },
        { prop: 'title', label: '标题' },
        { prop: 'content', label: '内容' },
        { prop: 'status', label: '是否启用' },
        { prop: 'jumpTo', label: '跳转页面' }
      ],

      visibleDrawer: false,
      id: null,
    }
  },
  methods: {
    advertisingClick(row) {
      this.visibleDrawer = true;
      this.id = row.id;
    },
    advertisingClose() {
      this.visibleDrawer = false;
      this.id = null;
      this.$refs.customTable.listFn();
    },

    advertisingAdd() {
      this.visibleDrawer = true;
    },

    /* 接口请求-编辑 */
    async putFn(row, status) {
      let url = '/api/v1/manage/banner/sticker';
      let params = Object.assign(row, { status });
      let data = await this.$axios.put(url, params);
      if (data && data.code === 1) {
        this.$message.success(`已${row.status == 1 ? '开启' : '关闭'}`);
        this.$refs.customTable.listFn();
      }
    },
    /* 开关 */
    switchClick(row) {
      this.$confirm(`确认要${row.status === 1 ? '关闭' : '开启'}吗?`, '提示').then(async () => {
        let status = row.status === 1 ? 2 : 1
        this.putFn(row, status)
      })
    },

    /* 接口调用-排序 */
    async postSort(bannerSort) {
      let url = '/api/v1/manage/banner/sticker/sort';
      let params = {
        sort: bannerSort
      }
      let data = await this.$axios.post(url, params);
      if (data && data.code === 1) {
        this.$message.success('操作成功！');
        this.$refs.customTable.listFn();
      }
    },

    /* 下移 */
    moveClick(row, type) {
      let index = this.$refs.customTable.table.content.findIndex(value => value.id === row.id);

      if (type === 'up') {
        this.$refs.customTable.table.content[index].sort -= 1;
        this.$refs.customTable.table.content[index - 1].sort += 1;
      } else if (type === 'down') {
        this.$refs.customTable.table.content[index].sort += 1;
        this.$refs.customTable.table.content[index + 1].sort -= 1;
      }
      let bannerSort = JSON.stringify(this.$refs.customTable.table.content);
      this.postSort(bannerSort)
    },

    /* 列表-删除 */
    removeClick(row) {
      let text = row.status === 1 ? '删除后广告将不可见，确认删除吗?' : '确认要删除该广告吗?';
      this.$confirm(text, '删除提示').then(async () => {
        let url = '/api/v1/manage/banner/sticker';
        let params = {
          id: row.id
        }
        let data = await this.$axios.delete(url, params);
        if (data && data.code === 1) {
          this.$message.success('删除成功');
          this.$refs.customTable.listFn()
        }
      })
    }
  },
}
</script>

<style lang="less">
#sticker {
  .search-top-left {
    font-weight: 600;

    .second {
      color: #999;
    }

    .set {
      margin-left: 10px;
    }
  }

  .el-input {
    width: auto;
  }

  .el-table .cell.el-tooltip {
    display: flex;
  }
}
</style>
